// extracted by mini-css-extract-plugin
module.exports = {"Reveal":"RevealImage_Reveal__2pp1r","Revealed":"RevealImage_Revealed__w274M"};